import { SERVICE } from '@ds/swymkit/tools'
import {
  cacheDecorator,
  invalidateCacheIfSuccessfulDecorator,
} from '@ds/swymkit/tools'

import { commentFetch } from '~/services/fetch-comment'

import type { IFavorite } from '~/features-shared/favorites/interfaces/favorite'

import type { SwymResponse } from '~/interfaces/services-dto'

export function getFavorites(type: string) {
  return cacheDecorator(
    `favorites-list-${type}`,
    () => commentFetch
      .get(`/api/favorites/type/${type}`)
      .json<SwymResponse<IFavorite[]>>(),
    10 * 60000, // cache favorites for 10mn
  )
}

export function removeFavorite(type: string, subject_uri: string) {
  // If the call succeed, clean the cache on favorites list
  return invalidateCacheIfSuccessfulDecorator(
    `favorites-list-${type}`,
    () => commentFetch
      .delete(`/api/favorites/${subject_uri}/service_name/3DSwym/type/${type}`)
      .json<SwymResponse<void>>(),
  )
}

export function addFavorite(type: string, subject_uri: string, position: number) {
  // If the call succeed, clean the cache on favorites list
  return invalidateCacheIfSuccessfulDecorator(
    `favorites-list-${type}`,
    () => commentFetch
      .patch('/api/favorites', {
        json: {
          position,
          service_name: SERVICE.SWYM,
          subject_uri,
          type,
        },
      })
      .json<SwymResponse<IFavorite>>(),
  )
}
